import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { ApiHttpService } from 'src/app/core/services/api-http.service';

@Injectable({
  providedIn: 'root'
})
export class PontoBankTransactionsService {
  public openTransactionDrawerFlag: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private transactionDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public transationListRefresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  transactionDetailsObservable$ = this.transactionDetails.asObservable();
  transationListRefreshObservable$ = this.transationListRefresh.asObservable();
  public shouldTriggerRefreshOnClose = false;
  isLocal = false


  public selectedVehicle: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  selectedVehicleAsObservables$ = this.selectedVehicle.asObservable();

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private apiHttpService: ApiHttpService,
  ) { }

  public openDrawer(): void {
    this.openTransactionDrawerFlag.next(true);
  }

  public closeDrawer(): void {
    this.openTransactionDrawerFlag.value && this.openTransactionDrawerFlag.next(false);
  }

  public setTransactionDetails(data: any): void {
    !this.openTransactionDrawerFlag.value && this.transactionDetails.next(data);
  }
  public setTransationListRefresh(data: boolean): void {
    this.transationListRefresh.next(data);
  } 

  getPontoTranansactions(vehicleId: string, sortBy: string, orderBy: SortDirection, pgIndex: number, pgSize: number, params?: { [key: string]: any }, payload?: any) {
    const queryParams = {
      page: Number(pgIndex) + 1,
      pageSize: pgSize,
      sortBy: sortBy,
      order: orderBy,
      ...params
    };

    // Extract multi-select filters to body
    const body = {
      iban: payload?.iban || [],
      transactionType: payload?.transactionType || [],
      counterparty: payload?.counterparty || []
    };
    const url = this.apiEndpointsService.createUrl(
      `vehicles/${vehicleId}/transactions`,
      this.isLocal
    );
    return this.apiHttpService.post(url, body, { params: queryParams });
  }

  getAttachInvoices(vehicleId: string, transactionType: string, sortBy: string, orderBy: string, page: any, pageSize: any, search?: string) {
    const queryParams: { [key: string | number]: string | number } = {
      sort: sortBy,
      order: orderBy,
      page: page,
      pageSize: pageSize,
      purpose: 'paymentVerification',
      transactionType
    };
  
    if (search) {
      queryParams['search'] = search;
    }

    const url = this.apiEndpointsService.createUrlV2(
      `vehicle/${vehicleId}/invoice`,
      this.isLocal
    );
    return this.apiHttpService.get(url, { params: queryParams });
  }

  linkInvoice(transactionsId: string, invoiceId: Array<string | number>) {
    const body = {
      invoiceIds: invoiceId,
    };
    const url = `${this.apiEndpointsService.createUrlV2('transactions/link-invoice', false)}?transactionId=${transactionsId}`;
    return this.apiHttpService.put(url, body);
  }

  unlinkInvoice(transactionsId: string | number, invoiceId: Array<string | number>) {
    const body = {
      invoiceIds: invoiceId,
    };
    const url = `${this.apiEndpointsService.createUrlV2('transactions/unlink-invoice', false)}?transactionId=${transactionsId}`;
    return this.apiHttpService.put(url, body);
  } 

  getExcelFile(vehicleId: string, sortBy: string, orderBy: SortDirection, pgIndex: number, pgSize: number, params?: { [key: string]: any }, payload?: any) {
    const queryParams = {
      page: Number(pgIndex) + 1,
      pageSize: pgSize,
      sortBy: sortBy,
      order: orderBy,
      ...params
    };
    // Extract multi-select filters to body
    const body = {
      iban: payload?.iban || [],
      transactionType: payload?.transactionType || [],
      counterparty: payload?.counterparty || []
    };
    return this.apiHttpService.post(
      this.apiEndpointsService.createUrl(
        `vehicles/${vehicleId}/transactions`,
        this.isLocal
      ), body, { responseType: 'arraybuffer', params: queryParams }
    );
  }

}
